import "./productListing.scss";

import React, { useContext, useEffect, useState } from "react";

import FsLightbox from "fslightbox-react";
import { StaticImage } from "gatsby-plugin-image";
import { usePageLocalization } from "@sbi-international/boutik.gatsby.plugin.multilocale";
import { useTranslation } from "react-i18next";
import { getPriceAndCurrency } from "../../utils/localePrice";
import { ICurrentStock, ServicesContext } from "@sbi-international/boutik.gatsby.plugin.services";
import { getAvailability, productLiveAvailabilityLabel } from "../../utils/productAvailabilityInfo";
import { AddItemButton } from "@sbi-international/boutik.gatsby.plugin.checkout";
import { AccessoriesFilteredProduct } from "../../models/accessoriesFilteredProduct";
import ProductLiveAvailability from "../product/ProductLiveAvailability";
import { ProductStock } from "@sbi-international/boutik.gatsby.plugin.components";

type AccessoryProps = {
    product: AccessoriesFilteredProduct;
    hasOwnPage: boolean;
};

export default function Accessory(props: AccessoryProps) {
    const { product, hasOwnPage } = props;
    const { t } = useTranslation("templatePages");

    const [price, setPrice] = useState<string>("");
    const [currentStock, setCurrentStock] = useState<ICurrentStock>();
    const [availabilityInfo, setAvailabilityInfo] = useState<string>("--");

    const servicesContext = useContext(ServicesContext);
    const productService = servicesContext?.magento.productService;

    const { currentLocale, navigateTranslated } = usePageLocalization();
    const [isLightBoxVisible, setIsLightBoxVisible] = useState(false);

    const productImageSrc = product?.product?.fields?.imageUrls?.[0];

    const productImage =
        product?.product?.fields?.thumbnails?.[0]?.childImageSharp?.gatsbyImageData;

    const FsLightboxSrc =
        product?.product?.fields?.images?.[0]?.childImageSharp?.gatsbyImageData?.images?.fallback
            ?.src ?? productImageSrc;

    const clickImage = () => {
        product?.product?.fields?.images[0] && setIsLightBoxVisible(!isLightBoxVisible);
    };

    const clickTd = () => {
        product?.product?.slug?.[currentLocale] &&
            navigateTranslated(product.product.slug[currentLocale]);
    };

    const productTitle = (product?.product?.title && product?.product?.title[currentLocale]) + " ";

    const productCode = product?.product?.code ? product.product?.code : "";

    useEffect(() => {
        if (product) {
            setPrice(getPriceAndCurrency(product?.currentPrice));
            setCurrentStock(product?.currentStock ?? undefined);
        }
    }, [product]);

    return (
        <tr className="productInfos">
            <td
                className={FsLightboxSrc ? "image clickable" : "image"}
                onClick={() => {
                    clickImage();
                }}
            >
                {FsLightboxSrc && (
                    // @ts-ignore
                    <FsLightbox
                        toggler={isLightBoxVisible}
                        sources={[FsLightboxSrc]}
                        exitFullscreenOnClose={true}
                    />
                )}

                {productImage?.images?.fallback?.src ? (
                    <img src={productImage?.images?.fallback?.src} alt="" />
                ) : productImageSrc ? (
                    <img src={productImageSrc} alt="" />
                ) : (
                    <StaticImage
                        src={"../../images/product-image-placeholder.jpg"}
                        imgStyle={{ objectFit: "contain" }}
                        alt=""
                    />
                )}
            </td>
            <td
                className={hasOwnPage ? "td hasLink" : "td"}
                onClick={() => {
                    hasOwnPage && clickTd();
                }}
            >
                {productCode}
                <br />
                <span className="productName">{productTitle}</span>
                <br />
                {hasOwnPage && (
                    <div className="see-more">
                        <span>{t("see-more")}</span>
                    </div>
                )}
            </td>
            <td className="tdPriceAndStock">
                <div className="td-price-and-stock-container">
                    
                    <div className="price">{price}</div>
                    <div className="stock">                        
                        <ProductStock  type="medium-list" currentStock={currentStock}
                            isCustomMade={
                                product.product.attributes?.custom_made?.values?.[0]?.[
                                    currentLocale
                                ] ?? false
                            } />                        
                    </div>
                </div>
            </td>

            <td className="tdButton">
                <div className="addToCart">
                    <AddItemButton
                        type={"medium"}
                        sku={product?.product?.code}
                        availability={getAvailability(currentStock)}
                    />
                </div>
            </td>
        </tr>
    );
}
